// extracted by mini-css-extract-plugin
export default {"overdueText":"NextRepaymentText_overdueText","link":"NextRepaymentText_link"};